
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","width":"64","height":"64","x":"0","y":"0","maskUnits":"userSpaceOnUse"}},[_c('path',{attrs:{"fill":"#D1D1D4","d":"M0 0h64v64H0z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill":"#D1D1D4","fill-rule":"evenodd","d":"M43.669 20.148C43.669 26.694 38.363 32 31.817 32s-11.852-5.306-11.852-11.852S25.271 8.296 31.817 8.296c6.545 0 11.852 5.306 11.852 11.852zM27.335 35.555a12 12 0 00-11.624 9.017l-1.575 6.137c-.65 2.53 1.262 4.995 3.874 4.995h27.42c2.672 0 4.593-2.569 3.838-5.131l-1.89-6.41a12 12 0 00-11.51-8.608h-8.534z","clip-rule":"evenodd"}})])])
          )
        }
      }
    